// extracted by mini-css-extract-plugin
export var addWidgetButton = "_12-6";
export var backButton = "_12-1";
export var legacyWidgetContainer = "_12-5";
export var pageContainer = "_12-2";
export var settingsContent = "_12-0";
export var widgetSubsectionItem = "_12-3";
export var widgetSubsectionItemContent = "_12-4";